import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";
import { NAV } from "@/constants/testIds";

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleTheme}
      aria-label={isDark ? "Attiva modalità giorno" : "Attiva modalità notte"}
      data-testid={NAV.themeToggle}
      className="rounded-xl glow-hover"
    >
      {isDark ? (
        <Sun className="h-[1.15rem] w-[1.15rem]" data-testid={NAV.themeIcon} />
      ) : (
        <Moon className="h-[1.15rem] w-[1.15rem]" data-testid={NAV.themeIcon} />
      )}
    </Button>
  );
};
